import { render } from "./InvestmentsRedemption.vue?vue&type=template&id=63455ba0"
import script from "./InvestmentsRedemption.vue?vue&type=script&lang=js"
export * from "./InvestmentsRedemption.vue?vue&type=script&lang=js"
script.render = render

export default script